import React from 'react';

import { Icon } from '@/components/global/Icon';

import { TRecommendation } from '@/services/requests/Recommendation/types/template4';

type TProps = {
  data: TRecommendation;
};

export function Notes({ data }: TProps) {
  return (
    <p className="vitrine-template4__notes">
      <Icon
        name="info"
        size="small"
        className="vitrine-template4__notes-icon"
      />
      {data.info}
    </p>
  );
}
